import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { Auth0ClientService } from '@app/core/auth0-client.service';
import { OmRecaptchaComponent } from '@app/shared';

import { GetRegistrationContextGraphQLService } from './get-registration-context-graphql.service';

@Component({
  selector: 'om-auth-redirect',
  template: '<om-recaptcha #captcha></om-recaptcha>',
})
export class AuthRedirectComponent implements AfterViewInit {
  @ViewChild('captcha', { static: true }) captcha: OmRecaptchaComponent;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth0ClientService: Auth0ClientService,
    private getRegistrationContextGraphQL: GetRegistrationContextGraphQLService,
  ) {}

  ngAfterViewInit(): void {
    const hctx = this.route.snapshot.queryParamMap.get('hctx');
    const returnUrl = this.route.snapshot.queryParamMap.get('return_url');

    if (!hctx) {
      this.redirectToLogin();
      return;
    }

    this.performTokenHandoff(hctx, returnUrl);
  }

  private performTokenHandoff(contextId: string, returnUrl: string | null): void {
    this.captcha.getToken().pipe(
      switchMap((reCaptchaToken: string) =>
        this.getRegistrationContextGraphQL.mutate({
          input: {
            contextId,
            reCaptchaToken,
          },
        }),
      ),
    ).subscribe({
      next: result => {
        const token = result.data?.getRegistrationContext?.token;
        if (!token) {
          this.redirectToLogin();
          return;
        }

        this.auth0ClientService.persistToken(token);
        window.location.href = this.validateReturnUrl(returnUrl) ? returnUrl : '/';
      },
      error: () => {
        this.redirectToLogin();
      },
    });
  }

  private validateReturnUrl(url: string | null): boolean {
    if (!url) {
      return false;
    }
    if (!url.startsWith('/')) {
      return false;
    }
    if (url.startsWith('//')) {
      return false;
    }
    if (url.includes('://')) {
      return false;
    }
    return true;
  }

  private redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}